module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Contents")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "css-template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "Contents",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "chaptitle-pre",
    attrs: {
      "epub:type": "title",
      "id": "Contents"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "Page ix",
      "epub:type": "pagebreak",
      "id": "page_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('b', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Foreword"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "list-para3"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Foreword"
    }
  }, [_c('i', [_vm._v("A Tribute to Kathleen Steinhauer and Nellie Carlson")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para3"
  }, [_vm._v("MARIA CAMPBELL")]), _vm._v(" "), _c('p', {
    staticClass: "topspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-para2"
  }, [_c('a', {
    attrs: {
      "href": "#/08_Acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "topspace"
  }), _vm._v(" "), _c('p', {
    staticClass: "list-para2"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "list-para3"
  }, [_c('a', {
    attrs: {
      "href": "#/09_Introduction"
    }
  }, [_c('i', [_vm._v("Two Strong Women Begin to Tell a Story")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para3"
  }, [_vm._v("LINDA GOYETTE")]), _vm._v(" "), _c('p', {
    staticClass: "topspace1"
  }), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/10_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 "), _c('b', [_vm._v("Daughters of Saddle Lake")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('b', [_vm._v("Surviving Residential School")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('b', [_vm._v("Love, Matrimony, and the "), _c('i', [_vm._v("Indian Act")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('b', [_vm._v("Indian Rights for Indian Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('b', [_vm._v("A Tribute to Jenny Shirt Margetts")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('b', [_vm._v("How We Worked Together")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('b', [_vm._v("Fighting for Our Birthright")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para1"
  }, [_c('span', {
    attrs: {
      "href": "#/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('b', [_vm._v("This Is Our Land")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ClosingWords",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Closing Words")])])]), _vm._v(" "), _c('p', {
    staticClass: "topspace"
  }), _c('p', {
    staticClass: "list-para2a"
  }, [_c('span', {
    attrs: {
      "aria-label": "Page x",
      "epub:type": "pagebreak",
      "id": "page_x",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/19_FamilyTree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2a"
  }, [_c('span', {
    attrs: {
      "href": "#/21_Timeline",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2a"
  }, [_c('span', {
    attrs: {
      "href": "#/22_HonourRoll",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honour Roll")])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2a"
  }, [_c('span', {
    attrs: {
      "href": "#/23_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2a"
  }, [_c('span', {
    attrs: {
      "href": "#/24_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "list-para2a"
  }, [_c('span', {
    attrs: {
      "href": "#/25_FurtherReading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dae2c5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Contents.vue
// module id = 69
// module chunks = 0